<script setup lang="ts">
import BaseModal from '@/components/modals/BaseModal.vue'
import type { ModalData } from '@/types'
import { watch } from 'vue'
const props = defineProps({
  callbackFunction: {
    type: Function,
    required: true
  },
  uniqueId: {
    type: String,
    required: true
  }
})

let modalData: ModalData = {
  modalHeader: {
    title: 'Leaving Current Page',
    includeCloseBtnInHeader: true
  },
  modalSize: {
    minHeight: 162,
    maxWidth: 600,
    minWidth: 320
  },
  modalActions: {
    buttons: {
      okButton: {
        label: 'ok',
        bgColor: '#008272',
        color: 'white',
        callback: props.callbackFunction,
        size: 'large'
      },
      cancelButton: {
        label: 'Cancel',
        bgColor: '#ffffff',
        color: '#050F2D'
      }
    }
  }
}
watch(
  () => props.callbackFunction,
  (newValue: Function) => {
    if (
      modalData &&
      modalData.modalActions &&
      modalData.modalActions.buttons &&
      modalData.modalActions.buttons.okButton
    ) {
      modalData.modalActions.buttons.okButton.callback = newValue
    }
  }
)
</script>
<template>
  <BaseModal :modalData="modalData" :uniqueId="uniqueId">
    <p class="leaving-modal-font">
      We need to take you to a different page in DnA to complete this task
    </p>
  </BaseModal>
</template>
<style lang="scss">
.leaving-modal-font {
  font-family: 'Cerebri Sans';
  font-weight: 400;
  font-size: 14px;
  line-height: 17.78px;
  color: #050f2d;
}
</style>
